<script setup lang="ts">
import type { IBreadcrumb } from '~/types/ui'
import Breadcrumbs from '~/components/Global/Breadcrumbs.vue'
import SearchResult from '~/components/Search/SearchResult.vue'

const route = useRoute()

if (!route.query.q) {
  throw createError({
    statusCode: 404,
    message: 'Sidan finns inte',
  })
}

const searchString = ref<string>(route.query.q)

watch(
  () => route.query,
  () => {
    searchString.value = route.query.q
  },
  { deep: true },
)

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'Sökresultat',
    link: useRoute().fullPath,
  },
]
</script>

<template>
  <div>
    <Breadcrumbs :breadcrumbs="breadcrumbs" class="mx-5" />
    <div class="mx-4 space-y-10">
      <SearchResult :search-string="searchString" />
    </div>
  </div>
</template>
